import { inject, Injectable } from '@angular/core';
import { OrderStateServiceWrapper } from '../store/state/order/order.state.wrapper.service';
import { UserStateService } from '../store/state/user/user.state.service';

@Injectable({
  providedIn: 'root'
})
export class ZendeskService {

  orderStateService: OrderStateServiceWrapper = inject(OrderStateServiceWrapper);
  userStateService: UserStateService = inject(UserStateService);

  /**
   * Initialize Zendesk with user context immediately after login/script load
   */
  initializeZendesk() {
    // Wait for Zendesk to be available, then setup
    this.waitForZendeskAndSetup();
  }

  /**
   * Wait for Zendesk widget to be available before setup
   */
  private waitForZendeskAndSetup(maxAttempts: number = 10, attempt: number = 1) {
    if (this.isZendeskAvailable()) {
      this.setupZendesk();
    } else if (attempt < maxAttempts) {
      setTimeout(() => {
        this.waitForZendeskAndSetup(maxAttempts, attempt + 1);
      }, 500); // Check every 500ms
    } else {
      console.warn('Zendesk widget failed to load after maximum attempts');
    }
  }

  /**
   * Check if Zendesk is available
   */
  isZendeskAvailable(): boolean {
    return !!(window as any).zE && typeof (window as any).zE === 'function';
  }

  toggleLiveChat() {
    if (this.isZendeskAvailable()) {
      (window as any).zE('messenger', 'open');
    } else {
      console.warn('Zendesk is not available');
    }
  }

  setupZendesk() {
    try {
      if (!this.isZendeskAvailable()) {
        console.warn('Zendesk is not available for setup');
        return;
      }

      const user = this.userStateService.getUser();
      const preOrder = this.orderStateService.getPreOrder();
      
      // Build user information with fallbacks
      const userName = user ? `${user.FirstName || ''} ${user.LastName || ''}`.trim() : '';
      const userEmail = user?.LoginEmail || user?.ContactEmail || '';
      const userDealer = preOrder?.DealerName || '';
      const orderNumber = preOrder?.OrderNumber || '';

      // Set conversation tags
      (window as any).zE("messenger:set", "conversationTags", ["web_ui_chat", "order_entry"]);
      
      // Set conversation fields with user context
      (window as any).zE("messenger:set", "conversationFields", [
        { id: "17612705795092", value: userName },     // Custom field for user name
        { id: "17612660928916", value: userEmail },    // Custom field for user email  
        { id: "17612768220564", value: userDealer },   // Custom field for dealer
        { id: "17612755980948", value: orderNumber }   // Custom field for order number
      ]);

      console.log('Zendesk initialized with user context:', { userName, userEmail, userDealer, orderNumber });
    } catch (error) {
      console.error('Failed to setup Zendesk:', error);
    }
  }
}
